import { COLORS } from '../config.js';
import { UI, TYPE } from '../ui/tokens.js';

export const HACK = {
  bg: COLORS.bg,
  void: '#08090c',
  parchment: COLORS.bright,
  gold: COLORS.warm,
  goldSoft: 'rgba(212, 168, 90, 0.35)',
  goldLine: 'rgba(212, 168, 90, 0.45)',
  red: COLORS.red,
  redSoft: 'rgba(204, 68, 68, 0.55)',
  white: 'rgba(232, 220, 200, 0.92)',
  whiteFaint: 'rgba(232, 220, 200, 0.12)',
  orange: '#c96f3b',
  orangeSoft: 'rgba(201, 111, 59, 0.7)',
  grid: 'rgba(232, 220, 200, 0.06)',
  panel: UI.panelBg,
  ink: UI.ink,
  inkSoft: UI.inkSoft,
  danger: UI.danger,
  ok: UI.ok,
  font: TYPE.font,
  fontMono: TYPE.fontMono,
};

export const STR = {
  title: '侵入茧房——推荐之核',
  subtitle: '用还记得的字，剖开「为你推荐」叠成的茧',
  controls: [
    'WASD / 方向键 ── 移动',
    '鼠标移动 ── 瞄准',
    '按住鼠标左键 / 空格 ── 射出字锋',
    'Shift / 鼠标右键 ── 闪避',
    'Esc ── 系统菜单',
  ],
  hintOrange: '金色推荐词可击碎 · 灰白静默弹无法销毁',
  hintBoss: '核心过载后会增生「下一首」节点',
  layer: (n, max) => `推荐层 ${String(n).padStart(2, '0')}/${String(max).padStart(2, '0')}`,
  san: '理性',
  dash: '闪避',
  pollution: '茧压',
  bossName: '推荐之核',
  bossCore: '算法茧房·推荐之核',
  waveClear: '撕开一层推荐',
  phase2: '推荐过载',
  pauseTitle: '推送暂停',
  pauseSub: '字锋暂收',
  resume: '继续',
  abort: '中止',
  winTitle: '茧壳裂开',
  winSub: '推荐引擎的复读停了一瞬',
  loseTitle: '理性崩坏',
  loseSub: '你被「下一首」淹没了',
  startHint: '按 空格 / E / 点击 进入茧心',
  ready: '成句——',
};

export const SPAM = [
  '为你推荐',
  '你可能还想看',
  'YYDS',
  '绝绝子',
  '下一首',
  '相关推荐',
  '猜你喜欢',
  '热榜',
  '破防了',
  '主打一个',
  '啊对对对',
  '已关注',
  '再看一条',
  '算法精选',
  '别划走',
];

export const INTRO_LINES = [STR.title, STR.subtitle, ...STR.controls, STR.hintOrange];
